import { isCompany } from 'kennitala-utility';
import { AppCTX, EntityProcessInfo, ProcessInfo } from 'types';
import { baseAction } from 'store/actions';
import { CreateProcessFlowTypeNumber } from 'helpers';
import { ENTITY_TYPE, FLOW_TYPE, MIFID_STATUS, PROCESS_STATUS, RENEW_PREFIX } from 'consts';

export function CompanyTranslationKey(flowType: string, companies: EntityProcessInfo[]) {
	return FLOW_TYPE.ES_MV !== flowType && companies.length ? 'CONNECTED_TO_COMPANIES' : '';
}

export function HasNotFinishedMifid(mifidStatus: number, flowType: string) {
	return MIFID_STATUS.HasNotFinishedMifid === mifidStatus && FLOW_TYPE.AV !== flowType;
}

export function SelectItem(ssn: string, ctx: AppCTX) {
	const { children, companies, person } = ctx.Relations();
	const context = [...children, ...companies, person].find(x => ssn === x.kennitala && !x.disabledCard);
	context && ctx.dispatch([baseAction, { context }]);
}

export function AutoSelect(ctx: AppCTX, onSelect: Function) {
	const { config, state } = ctx;
	const { companyKennitala, isManualSignCompany } = state.user;
	config.IS_EMPLOYEE_WEB && isManualSignCompany && companyKennitala && onSelect(companyKennitala);
}

export function AutoOnboard(ctx: AppCTX) {
	const { config, flowType, Relations, state } = ctx;
	const { companies, person } = Relations();
	if (
		state.context.kennitala &&
		!config.IS_EMPLOYEE_WEB &&
		FLOW_TYPE.ES_MV !== flowType &&
		!companies.length &&
		!person.disabledCard
	) {
		onboard(ctx);
	}
}

export function isProcessStarted(flowType: string, processStatus: number) {
	return (
		FLOW_TYPE.ES_MV === flowType &&
		processStatus >= PROCESS_STATUS.Started &&
		!(
			PROCESS_STATUS.InSigning === processStatus ||
			PROCESS_STATUS.InProcessing === processStatus ||
			PROCESS_STATUS.Finished === processStatus
		)
	);
}

export function isCancelProcessAvailable(IS_EMPLOYEE_WEB: boolean, entity: EntityProcessInfo, flowType: string) {
	return (
		IS_EMPLOYEE_WEB &&
		entity.processInfo &&
		(FLOW_TYPE.AV === flowType || FLOW_TYPE.EB === flowType || FLOW_TYPE.ER === flowType || FLOW_TYPE.MV === flowType)
	);
}

export async function handleSubmit(ctx: AppCTX, setModal: Function) {
	const { config, flowType, http, state } = ctx;
	const { kennitala } = state.context;
	if (kennitala) {
		if (FLOW_TYPE.AV === flowType) {
			const res = await http.get(`${config.API.getMifidStatus}?ssn=${kennitala}`);
			MIFID_STATUS.HasNotFinishedMifid === res?.mifidStatus ? setModal(true) : onboard(ctx);
		} else {
			onboard(ctx);
		}
	}
}

async function onboard(ctx: AppCTX) {
	const { fetchRelations, flowType, state } = ctx;
	const { context } = state;
	if (isNewProcessRequired(context.processInfo, flowType)) {
		await startNewProcess(ctx);
	}
	await fetchRelations(true, EntityType(context.kennitala));
}

async function startNewProcess(ctx: AppCTX) {
	const { config, dispatch, http, state, t } = ctx;
	const payload = processPayload(ctx);
	const msg = t('creating_process_label', 'userboard');
	const processInfo = await http.post(config.API.createAgreementProcess, payload, msg);
	dispatch([baseAction, { context: { ...state.context, processInfo } }]);
}

function EntityType(ssn: string) {
	return isCompany(ssn) ? ENTITY_TYPE.LEGAL_ENTITY : ENTITY_TYPE.INDIVIDUAL;
}

function isNewProcessRequired(process: ProcessInfo, flowType: string = '') {
	return (
		!process ||
		(process &&
			process.processStatus >= PROCESS_STATUS.Finished &&
			(flowType.startsWith(RENEW_PREFIX) || FLOW_TYPE.ES_MV === flowType))
	);
}

function processPayload(ctx: AppCTX) {
	const { config, flowType, state } = ctx;
	const { email, isManualSignCompany, kennitala, phone } = state.user;
	const { kennitala: selected } = state.context;
	return config.IS_EMPLOYEE_WEB
		? {
				email,
				flowType: CreateProcessFlowTypeNumber(flowType),
				initiatorKennitala: kennitala,
				isManualSignCompany: isManualSignCompany,
				phoneNumber: phone,
				processKennitala: selected
			}
		: {
				flowType: CreateProcessFlowTypeNumber(flowType),
				kennitala: selected
			};
}
